import AgingReportShell from './AgingReportShell';

// ─────────────────────────────────────────────────────────────────
// Glass-i — Creditors Aging page (Stage 6E.3).
//
// Supplier outstanding broken into aging buckets. Read-only. Reads
// posted accounting_voucher_lines on creditor (sundry_creditor)
// ledgers, applies FIFO allocation between credits (bills) and debits
// (payments), and bucket-splits the remaining open lines.
// ─────────────────────────────────────────────────────────────────

export default function CreditorsAgingPage() {
  return (
    <AgingReportShell
      reportType="creditors"
      title="Creditors Aging"
      subtitle="Track supplier outstanding and overdue payables."
      partyColumnTitle="Supplier / Ledger"
      emptyContextKey="creditors_aging"
      errorContextKey="creditors_aging"
      totalCardLabel="Total Payables"
    />
  );
}
